/**
 * Input Type Constants
 *
 * Single source of truth for all input type strings.
 * Use these constants instead of string literals to ensure type safety
 * and make refactoring easier.
 *
 * @example
 * ```typescript
 * import { INPUT_TYPES } from './constants/input-types';
 *
 * const widget = {
 *   type: 'inline-input',
 *   inputType: INPUT_TYPES.NUMERIC,
 *   digits: 2
 * };
 * ```
 */

/**
 * Input Types
 *
 * These are the input types used for inline input widgets.
 */
export const INPUT_TYPES = {
  /** String/text input */
  STRING: 'string',

  /** Numeric input (digits only) */
  NUMERIC: 'numeric',
} as const;

/**
 * Type helper to get all input type values as a union type
 */
export type InputType = typeof INPUT_TYPES[keyof typeof INPUT_TYPES];
